module.exports = __webpack_public_path__ + "static/img/twjd-sdo17.3ee624d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/twjd-sdo17.png
// module id = 859
// module chunks = 0